"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../../../utils/utils");
var Field_1 = __importDefault(require("../../components/Field"));
var Label_1 = __importDefault(require("../../components/Label"));
var PridatZpracovateleField_1 = require("../ZpracovatelField/PridatZpracovateleField");
var Jazyky_1 = __importDefault(require("./Jazyky"));
var JazykyField_1 = require("./JazykyField");
var filterAvailable = function (selectedIds) { return ramda_1.filter(function (jazyk) { return !ramda_1.includes(jazyk.id, selectedIds); }); };
var mapToOptions = ramda_1.map(function (jazyk) { return ({ value: jazyk.id, label: jazyk.nazev }); });
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var UkonyJazykyField = function (_a) {
    var _b;
    var name = _a.name, label = _a.label, loading = _a.loading, error = _a.error, jazyky = _a.jazyky, specializace = _a.specializace, readOnly = _a.readOnly, isPreklUkon = _a.isPreklUkon;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _c = formik_1.useField(name), field = _c[0], meta = _c[1], helpers = _c[2];
    var value = field.value || [];
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    var handleChange = function (index) { return function (idJazyku) {
        var jazyk = jazyky === null || jazyky === void 0 ? void 0 : jazyky.find(function (j) { return j.id === idJazyku; });
        if (typeof idJazyku === 'object') {
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), idJazyku, value));
        }
        else if (jazyk) {
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), __assign(__assign({}, jazyk), { specializace: value[index].specializace }), value));
        }
    }; };
    var handleAdd = function () {
        helpers.setValue(ramda_1.append({}, value));
    };
    var handleRemove = function (index) { return function () {
        helpers.setValue(ramda_1.remove(index, 1, value));
    }; };
    if (!value.length) {
        handleAdd();
    }
    return (react_1.default.createElement(Field_1.default, { loading: loading, error: error, topAlign: true },
        react_1.default.createElement(Label_1.default, { htmlFor: utils_1.NormalizeString(name) }, label),
        react_1.default.createElement(PridatZpracovateleField_1.BorderDiv, { "$hasError": !!meta.error },
            ramda_1.addIndex(ramda_1.map)(function (jazyk, index) {
                var usedIds = ramda_1.without([jazyk.id], ramda_1.pluck('id', field.value));
                var options = ramda_1.pipe(filterAvailable(usedIds), mapToOptions)(jazyky || []);
                return (react_1.default.createElement(Jazyky_1.default, { key: jazyk.id || "create-" + index, jazyk: jazyk, onChange: handleChange(index), onRemove: handleRemove(index), options: function () { return Promise.resolve(options); }, showRemove: value.length > 1, specs: specializace, readOnly: readOnly, isPreklUkon: isPreklUkon }));
            }, value),
            value.length < ((_b = jazyky === null || jazyky === void 0 ? void 0 : jazyky.length) !== null && _b !== void 0 ? _b : 0) && !readOnly && (react_1.default.createElement(JazykyField_1.Pridat, { type: "button", onClick: handleAdd, name: "PridatJazyk" }, "+ P\u0159idat jazyk")))));
};
UkonyJazykyField.defaultProps = {
    readOnly: undefined,
    isPreklUkon: undefined,
};
exports.default = UkonyJazykyField;
